import { convertImageFromDto } from "@modules/dtos/imageDto"
import { type UserDto } from "@modules/profile/userProfile/userDto"
import { type HUImage } from "@modules/types/imageTypes"

export class UserEntity {
  id: string
  username: string
  firstname: string
  lastname: string
  avatar: HUImage | null

  private constructor(user: UserEntity) {
    this.id = user.id
    this.username = user.username
    this.firstname = user.firstname
    this.lastname = user.lastname
    this.avatar = user.avatar
  }

  static fromDto(dto: UserDto): UserEntity {
    return new UserEntity({
      id: dto.id,
      username: dto.username,
      firstname: dto.firstname,
      lastname: dto.lastname,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : null,
    })
  }
}
